/**
 * 电子回单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/payCenter/invoiceRecord' }"
        >财务中心</el-breadcrumb-item
      >
      <el-breadcrumb-item>开票申请</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :model="formInline" class="user-search" label-width="100px">
      <el-row :gutter="10">
        <el-col :md="8" :xl="4">
          <el-form-item label="商户名称 :">
            <el-input
              size="small"
              v-model="formInline.merchantName"
              placeholder="请输入商户名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="开票记录id :">
            <el-input
              size="small"
              v-model="formInline.recordId"
              placeholder="请输入开票记录id"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="开票类型:" prop="invoiceType">
            <el-select
              size="small"
              v-model="formInline.invoiceType"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(val, index) in invoiceTypeList"
                :label="val.invoiceTypeDesc"
                :value="val.id"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="开票类目 :">
            <el-input
              size="small"
              v-model="formInline.invoiceCategory"
              placeholder="请输入开票类目"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="开票状态 :">
            <el-select
              size="small"
              v-model="formInline.recordStatus"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(val, index) in statusList"
                :label="val.label"
                :value="val.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="申请类型 :">
            <el-select
              size="small"
              v-model="formInline.recordType"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(val, index) in typeList"
                :label="val.label"
                :value="val.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="申请时间 : ">
            <el-date-picker
              size="small"
              v-model="date"
              type="daterange"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="上传时间 : ">
            <el-date-picker
              size="small"
              v-model="uploadDate"
              type="daterange"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label-width="30px">
            <el-button size="small" type="primary" @click="search"
              >搜索</el-button
            >
            <el-button size="small" @click="reset()">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div style="margin-bottom: 10px">
      <el-button
        size="small"
        type="primary"
        :loading="exportLoading"
        @click="exportdata"
        >导出数据</el-button
      >
    </div>

    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
      <el-table-column
        fixed
        prop="recordId"
        label="开票记录id"
        min-width="100px"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.recordId)">
            {{ scope.row.recordId }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="companyName"
        label="公司名称"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.companyName)">
            {{ scope.row.companyName }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="invoiceAmount"
        label="开票金额"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ scope.row.invoiceAmount.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="serviceFee" label="服务费" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.serviceFee.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="manageFee" label="管理费" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.manageFee.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="invoiceType"
        label="发票类型"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="invoiceCategory"
        label="发票类目"
        show-overflow-tooltip
      >
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.invoiceCategory)">
            {{ scope.row.invoiceCategory }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="recordStatus"
        label="开票状态"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span
            :style="{
              color: getStatusColor(scope.row.recordStatus),
            }"
          >
            {{ statusList[scope.row.recordStatus - 1].label }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="recordTypeStr"
        label="申请类型"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="remark" label="备注" show-overflow-tooltip>
        <template #default="scope">
          <span @dblclick="copyToClipboard(scope.row.remark)">
            {{ scope.row.remark }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="submissionTime"
        label="申请时间"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column prop="uploadTime" label="上传时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="invoiceInfo"
        label="开票信息"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-link type="primary" @click="showInvoiceInfo(scope.row)"
            >查看</el-link
          >
        </template>
      </el-table-column>
      <el-table-column prop="invoiceDtl" label="开票详情" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-link type="primary" @click="viewInvoiceDtl(scope.row.recordId)"
            >查看</el-link
          >
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" min-width="220">
        <template #default="scope">
          <el-button
            v-if="showActionButtons()"
            size="small"
            text
            type="primary"
            @click="onUpload(scope.row)"
            >上传</el-button
          >
          <el-button
            v-if="showActionButtons()"
            size="small"
            text
            type="warning"
            @click="onRejectInvoice(scope.row.recordId)"
            >驳回</el-button
          >
          <el-button
            v-if="showActionButtons()"
            size="small"
            text
            type="danger"
            @click="onCancelInvoice(scope.row.recordId)"
            >作废</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="background-color: #fff; padding: 15px; margin: 20px auto">
      <el-row :gutter="20">
        <el-col :span="8"
          ><div>
            <div class="m-bott-15">
              <span>总服务费：</span
              ><span>{{
                formatNumber(currentPageSummary.totalServiceFee)
              }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="8"
          ><div>
            <div class="m-bott-15">
              <span>总管理费：</span
              ><span>{{
                formatNumber(currentPageSummary.totalManagementFee)
              }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="8"
          ><div>
            <div class="m-bott-15">
              <span>总开票金额：</span
              ><span>{{
                formatNumber(currentPageSummary.totaInvoiceAmt)
              }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>

    <!-- 编辑界面 -->
    <el-dialog
      :title="editDetailTitle"
      :visible.sync="editVisible"
      width="810px"
      @close="closeDialog"
    >
      <el-form
        label-position="left"
        label-width="110px"
        :model="editDetailForm"
        :rules="rules"
        ref="editForm"
      >
        <!-- 姓名和证件类型 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发票代码" prop="invoiceCode">
              <el-input
                style="width: 230px"
                size="small"
                v-model="editDetailForm.invoiceCode"
                auto-complete="off"
                placeholder="发票代码"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发票票号" prop="invoiceNumber">
              <el-input
                style="width: 230px"
                size="small"
                v-model="editDetailForm.invoiceNumber"
                auto-complete="off"
                placeholder="发票票号"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="开票总金额" prop="totalAmount">
              <el-input
                style="width: 230px"
                size="small"
                v-model="editDetailForm.totalAmount"
                auto-complete="off"
                placeholder="开票总金额，红冲发票填写负数"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开票总金额(中)" prop="totalAmountCh">
              <el-input
                style="width: 230px"
                size="small"
                v-model="editDetailForm.totalAmountCh"
                auto-complete="off"
                placeholder="开票金额中文大写-总金额"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="红冲" prop="isNegative">
              <el-select
                v-model="editDetailForm.isNegative"
                placeholder="请选择是否为红冲发票"
                size="small"
                style="width: 230px"
              >
                <el-option
                  v-for="item in negativeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上传发票" prop="uploadInvoice">
              <el-upload
                class="upload-demo"
                ref="upload"
                action=""
                :on-remove="handleRemove"
                :on-change="fileOnChange"
                :file-list="fileList"
                :auto-upload="false"
                multiple
                accept=".pdf"
                :limit="100"
              >
                <el-button size="small" type="primary">上传发票</el-button>
                <div slot="tip" class="el-upload__tip">只能上传pdf文件</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="onCancel">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="onSubmit()"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :title="invoiceInfoDialog.title"
      :visible.sync="invoiceInfoDialog.show"
      width="800px"
    >
      <el-form
        label-position="left"
        :model="invoiceInfoForm"
        :rules="rules.invoiceInfoRules"
        ref="invoiceInfoFormRef"
        label-width="120px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="公司名称" prop="companyName">
              <el-input
                size="small"
                v-model="invoiceInfoForm.companyName"
                placeholder="请输入公司名称"
                clearable
                readonly
                @dblclick.native="copyText($event)"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税务登记号" prop="taxNumber">
              <el-input
                size="small"
                v-model="invoiceInfoForm.taxNumber"
                placeholder="请输入税务登记号"
                clearable
                readonly
                @dblclick.native="copyText($event)"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户行：" prop="depositBank">
              <el-input
                size="small"
                v-model="invoiceInfoForm.depositBank"
                placeholder="请输入开户行"
                clearable
                readonly
                @dblclick.native="copyText($event)"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户行帐号：" prop="depositBankAccount">
              <el-input
                size="small"
                v-model="invoiceInfoForm.depositBankAccount"
                placeholder="请输入开户行帐号"
                clearable
                readonly
                @dblclick.native="copyText($event)"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话：" prop="phone">
              <el-input
                size="small"
                v-model="invoiceInfoForm.phone"
                placeholder="请输入电话"
                clearable
                readonly
                @dblclick.native="copyText($event)"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="地址：" prop="address">
              <el-input
                size="small"
                v-model="invoiceInfoForm.address"
                placeholder="请输入地址"
                clearable
                readonly
                @dblclick.native="copyText($event)"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收件人：" prop="addresseeName">
              <el-input
                size="small"
                v-model="invoiceInfoForm.addresseeName"
                placeholder="请输入收件人"
                clearable
                readonly
                @dblclick.native="copyText($event)"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号：" prop="mobile">
              <el-input
                size="small"
                v-model="invoiceInfoForm.mobile"
                placeholder="请输入手机号"
                clearable
                readonly
                @dblclick.native="copyText($event)"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发送至邮箱：" prop="sendToMail">
              <el-input
                size="small"
                v-model="invoiceInfoForm.sendToMail"
                placeholder="发送至邮箱"
                clearable
                readonly
                @dblclick.native="copyText($event)"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电子发票格式">
              <el-select
                size="small"
                v-model="invoiceInfoForm.electronicInvoiceFormat"
                placeholder="请选择"
                style="width: 100%"
                readonly
                @dblclick.native="copyText($event)"
              >
                <el-option
                  v-for="item in electronicInvoiceFormat_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮寄地址:">
              <el-input
                size="small"
                v-model="invoiceInfoForm.mailingAddress.province"
                placeholder="省"
                clearable
                readonly
                @dblclick.native="copyText($event)"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                size="small"
                v-model="invoiceInfoForm.mailingAddress.city"
                placeholder="市"
                clearable
                readonly
                @dblclick.native="copyText($event)"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                size="small"
                v-model="invoiceInfoForm.mailingAddress.district"
                placeholder="区"
                clearable
                readonly
                @dblclick.native="copyText($event)"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                size="small"
                v-model="invoiceInfoForm.mailingAddress.detail"
                auto-complete="off"
                placeholder="邮寄地址"
                readonly
                @dblclick.native="copyText($event)"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  invoiceRecords,
  uploadInvoiceDetail,
  updateRecordStatus,
  exportinvoicerecords,
  getinvoicetypes,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
import { Message, MessageBox } from "element-ui";
import { china } from "../../common/area.js";
export default {
  data() {
    return {
      roleId: null,
      invoiceTypeList: [],
      infos: {
        totalServiceFee: 0,
        totalManagementFee: 0,
        totaInvoiceAmt: 0,
      },
      editDetailTitle: "上传发票",
      editVisible: false,
      uploadDate: [],
      date: [],
      fileList: [],
      listData: [],
      loading: false, //是显示加载
      negativeOptions: [
        {
          label: "否",
          value: 0,
        },
        {
          label: "是",
          value: 1,
        },
      ],
      invoiceStatusList: [
        {
          label: "正常发票",
          value: 1,
        },
      ],
      statusList: [
        {
          label: "待开票",
          value: 1,
        },
        {
          label: "成功",
          value: 2,
        },
        {
          label: "失败",
          value: 3,
        },
        {
          label: "作废",
          value: 4,
        },
        {
          label: "作废重传",
          value: 5,
        },
      ],
      typeList: [
        {
          label: "正常申请",
          value: 0,
        },
        {
          label: "预开",
          value: 1,
        },
      ],
      exportLoading: false,
      province_list: [],
      city_list: [],
      district_list: [],
      invoiceInfoDialog: {
        isViewMode: false,
        show: false,
        type: "",
        title: "",
        submitTxt: "",
      },

      electronicInvoiceFormat_list: [
        {
          label: "PDF格式",
          value: 1,
        },
        {
          label: "OFD格式",
          value: 2,
        },
        {
          label: "XML格式",
          value: 3,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      invoiceInfoForm: {
        sysUserId: "",
        companyName: "",
        depositBank: "",
        depositBankAccount: "",
        phone: "",
        address: "",
        addresseeName: "",
        mobile: "",
        sendToMail: "",
        electronicInvoiceFormat: "",
        mailingAddress: {
          city: "",
          district: "",
          province: "",
          detail: "",
        },
      },
      editDetailForm: {
        recordId: "", // 开票记录id
        invoiceAmount: "", // 开票金额
        isNegative: 0, // 是否红冲发票
        invoiceCategory: "", // 发票类目
        invoiceType: "", // 发票类型
        submissionTime: "", // 申请时间
        recordStatus: "", // 开票状态 1：处理中 2：成功 3：失败 4：作废
        invoiceStatus: 1, // 默认1 正常发票 后期如果有需求在修改
        remark: "", // 备注
      },
      // rules表单验证
      rules: {
        totalAmount: [
          { required: true, message: "开票总金额", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              // 允许为空（由required规则处理）
              if (value === undefined || value === null || value === "") {
                return callback();
              }

              // 校验是否为数字（允许负号）
              const regex = /^-?\d+(\.\d+)?$/;
              if (!regex.test(value)) {
                return callback(new Error("请输入有效的数字，可以包含负号"));
              }

              // 校验红冲金额不超过申请金额
              if (parseFloat(value) < 0) {
                const rowTotal = this.editDetailForm.rowTotalAmount;
                if (Math.abs(parseFloat(value)) > rowTotal) {
                  return callback(new Error("红冲发票金额超过申请金额"));
                }
              }

              callback();
            },
            trigger: "blur",
          },
        ],
        isNegative: [
          {
            required: true,
            message: "请选择是否为红冲发票",
            trigger: "change",
          },
        ],
        totalAmountCh: [
          { validator: this.validateTotalAmountCh, trigger: "blur" },
        ],
      },
      formInline: {
        page: 1,
        pageSize: 10,
        recordStatus: "",
        recordType: "",
        startDate: "",
        endDate: "",
        invoiceCategory: "",
        recordId: "",
        merchantName: "",
        date: [],
        uploadDate: [],
        isGetInvoiceInfo: 1,
      },

      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },

  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.roleId = JSON.parse(localStorage.getItem("user_info")).roleId;

    this.getdata(this.formInline);

    this.getInvoiceTypeList();
  },
  computed: {
    currentPageSummary() {
      const summary = this.listData.reduce(
        (acc, item) => {
          acc.totalServiceFee += Number(item.serviceFee || 0);
          acc.totalManagementFee += Number(item.manageFee || 0);
          acc.totaInvoiceAmt += Number(item.invoiceAmount || 0);
          return acc;
        },
        {
          totalServiceFee: 0,
          totalManagementFee: 0,
          totaInvoiceAmt: 0,
        }
      );

      // 更新 infos 对象
      this.infos.totalServiceFee = summary.totalServiceFee;
      this.infos.totalManagementFee = summary.totalManagementFee;
      this.infos.totaInvoiceAmt = summary.totaInvoiceAmt;

      return this.infos;
    },
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    showActionButtons() {
      console.log(this.roleId);
      if (this.roleId === 1 || this.roleId === 2) {
        return true;
      }
      return false;
    },
    getStatusColor(status) {
      // 根据状态值返回对应的颜色
      switch (status) {
        case 1:
          return "#409EFF"; // 蓝色
        case 2:
          return "#67C23A"; // 绿色
        case 3:
          return "#909399"; // 灰色
        case 4:
          return "#F56C6C"; // 红色
        case 5:
          return "#E6A23C"; // 黄色
        default:
          return "#303133"; // 默认黑色
      }
    },
    getInvoiceTypeList() {
      getinvoicetypes().then((res) => {
        if (res.msg !== "success") {
          this.$message({
            type: "error",
            message: res.msg,
          });
          return;
        }
        if (res.data.items.length == 0) {
          this.$message({
            type: "error",
            message: "开票类型未配置，请联系管理员配置",
          });
          return;
        }
        this.invoiceTypeList = res.data.items;
      });
    },
    copyToClipboard(text) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(
          () => {
            this.$message({
              message: "已复制",
              type: "success",
            });
          },
          () => {
            this.$message.error("复制失败，请重试！");
          }
        );
      } else {
        // 兼容旧浏览器
        const input = document.createElement("textarea");
        input.value = text;
        document.body.appendChild(input);
        input.select();
        try {
          document.execCommand("copy");
          this.$message({
            message: "已复制",
            type: "success",
          });
        } catch (err) {
          this.$message.error("复制失败，请重试！");
        }
        document.body.removeChild(input);
      }
    },
    validateTotalAmountCh(rule, value, callback) {
      if (!value) {
        callback();
      }

      const chineseDigits = /^[壹贰叁肆伍陆柒捌玖拾佰仟万亿圆角分零整]+$/i.test(
        value
      );

      if (!chineseDigits) {
        callback(new Error("开票总金额(中)必须是中文大写数字"));
      } else {
        callback();
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    fileOnChange(file, fileList) {
      this.fileList = fileList;
    },
    reset() {
      this.date = [];
      this.uploadDate = [];

      const page = this.formInline.page;
      const pageSize = this.formInline.pageSize;

      this.formInline = {
        page: page,
        pageSize: pageSize,
        recordStatus: "",
        recordType: "",
        startDate: "",
        endDate: "",
        invoiceCategory: "",
        recordId: "",
        merchantName: "",
        date: [],
        uploadDate: [],
        isGetInvoiceInfo: 1,
      };

      this.getdata(this.formInline);
    },

    exportdata() {
      let params = {
        page: 1,
        pageSize: 99999999,
        recordStatus: this.formInline.recordStatus,
        recordType: this.formInline.recordType,
        recordId: this.formInline.recordId,
        merchantName: this.formInline.merchantName,
        isGetInvoiceInfo: 1,
      };

      const [startDate = "", endDate = ""] = this.date || [];
      params.startDate = startDate;
      params.endDate = endDate;

      const [uploadStartDate = "", uploadEndDate = ""] = this.uploadDate || [];
      params.uploadStartDate = uploadStartDate;
      params.uploadEndDate = uploadEndDate;

      this.exportLoading = true;
      exportinvoicerecords(params).then((res) => {
        this.exportLoading = false;
        if (res.msg == "success") {
          window.open(res.data.downloadUrl);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },

    // 获取公司列表
    getdata(params) {
      this.loading = true;
      const [startDate = "", endDate = ""] = this.date || [];
      params.startDate = startDate;
      params.endDate = endDate;

      const [uploadStartDate = "", uploadEndDate = ""] = this.uploadDate || [];
      params.uploadStartDate = uploadStartDate;
      params.uploadEndDate = uploadEndDate;
      invoiceRecords(params)
        .then((res) => {
          this.loading = false;
          if (res.msg == "success") {
            this.listData = res.data.items;
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    onUpload(row) {
      this.editDetailForm = {
        recordId: "", // 开票记录id
        invoiceCode: "", // 发票代码
        invoiceNumber: "", // 发票票号
        invoiceDate: "", // 开票日期
        netAmount: "", // 开票金额-不含税金额
        isNegative: "", // 是否红冲发票
        totalAmount: "", // 开票金额-总金额
        totalAmountCh: "", // 开票金额中文大写-总金额
        invoiceStatus: 1, // 默认1 正常发票 后期如果有需求在修改
        rowTotalAmount: row.invoiceAmount,
      };
      this.editDetailForm.recordId = row.recordId;
      this.editVisible = true;
      this.fileList = [];
    },
    onCancelInvoice(recordId) {
      MessageBox.confirm(`此操作将开票申请作废，是否继续?`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const params = {
            recordId: recordId,
            recordStatus: 4,
          };
          this.formInline = {
            page: 1,
            pageSize: 10,
            recordStatus: "",
            startDate: "",
            endDate: "",
            invoiceCategory: "",
            recordId: "",
            merchantName: "",
            date: [],
            isGetInvoiceInfo: 1,
          };
          updateRecordStatus(params)
            .then((response) => {
              if (response.msg == "success") {
                Message.success("作废成功");
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "error",
                  message: response.msg,
                });
              }
            })
            .catch(() => {
              this.getdata(this.formInline);
            });
        })
        .catch(() => {});
    },
    onRejectInvoice(recordId) {
      MessageBox.confirm(`此操作将发票驳回，是否继续?`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const params = {
            recordId: recordId,
            recordStatus: 3,
          };
          this.formInline = {
            page: 1,
            pageSize: 10,
            recordStatus: "",
            startDate: "",
            endDate: "",
            invoiceCategory: "",
            recordId: "",
            merchantName: "",
            date: [],
            isGetInvoiceInfo: 1,
          };
          updateRecordStatus(params)
            .then((response) => {
              if (response.msg == "success") {
                Message.success("驳回成功");
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "error",
                  message: response.msg,
                });
              }
            })
            .catch(() => {
              this.getdata(this.formInline);
            });
        })
        .catch(() => {});
    },

    onCancel() {
      this.closeDialog();
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editVisible = false;
    },
    onSubmit() {
      if (
        this.editDetailForm.isNegative > 0 &&
        this.editDetailForm.totalAmount >= 0
      ) {
        this.$message.error("参数错误，红冲发票开票金额必须为负数");
        return;
      }

      if (
        this.editDetailForm.isNegative == 0 &&
        this.editDetailForm.totalAmount <= 0
      ) {
        this.$message.error("参数错误，正常发票开票金额必须为正数");
        return;
      }

      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const formData = new FormData();
          formData.append("recordId", this.editDetailForm.recordId);
          formData.append("invoiceCode", this.editDetailForm.invoiceCode);
          formData.append("invoiceNumber", this.editDetailForm.invoiceNumber);
          formData.append("invoiceDate", this.editDetailForm.invoiceDate);
          formData.append("netAmount", this.editDetailForm.netAmount);
          formData.append("isNegative", this.editDetailForm.isNegative);
          formData.append("totalAmount", this.editDetailForm.totalAmount);
          formData.append("totalAmountCh", this.editDetailForm.totalAmountCh);
          formData.append("invoiceStatus", this.editDetailForm.invoiceStatus);

          if (this.fileList && this.fileList.length > 0) {
            this.fileList.forEach((file, index) => {
              formData.append(`files`, file.raw); // 使用file.raw获取原始文件对象
            });
          } else {
            this.loading = false;
            this.$message({
              type: "error",
              message: "请上传有效的发票文件",
            });
            return;
          }
          uploadInvoiceDetail(formData)
            .then((res) => {
              this.loading = false;
              if (res.msg == "success") {
                this.closeDialog();
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    // 展示开票信息
    showInvoiceInfo(row) {
      if (row.invoiceInfo) {
        this.invoiceInfoDialog.title = "开票信息";
        this.invoiceInfoDialog.show = true;
        this.invoiceInfoDialog.isViewMode = true;
        this.invoiceInfoForm = row.invoiceInfo;
        if (!row.invoiceInfo.mailingAddress) {
          this.invoiceInfoForm.mailingAddress = {
            city: "",
            district: "",
            province: "",
            detail: "",
          };
        }
      } else {
        this.$message({
          type: "error",
          message: "未配置开票信息，请联系管理员配置",
        });
      }
    },
    viewInvoiceDtl(id) {
      this.$router.push({
        path: "/payCenter/invoiceRecordDtl",
        query: {
          id: id,
        },
      });
    },
    formatNumber(num) {
      return num ? num.toFixed(2) : "0.00";
    },

    copyText(event) {
      const target = event.target;
      let textToCopy;
      if (target.tagName === "SELECT") {
        textToCopy = target.value;
      } else if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") {
        textToCopy = target.value;
      } else {
        textToCopy = target.textContent;
      }
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          this.$message({
            message: "内容已复制到剪贴板",
            type: "success",
          });
        })
        .catch(() => {
          this.$message.error("复制失败，请手动复制");
        });
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
</style>

 


// WEBPACK FOOTER //
// src/views/payCenter/invoiceRecord.vue